package org.example.willfreightnew.components.models

enum class Section(
    val id: String,
    val title: String,
    val caps: String,
    val subtitle: String,
    val path: String
) {
    Home(
        id = "home",
        title = "Home",
        caps = "HOME",
        subtitle = "",
        path = "#home"
    ),
    About(
        id = "about",
        title = "About us",
        caps = "ABOUT US",
        subtitle = "Who We Are",
        path = "#about"
    ),
    Services(
        id = "services",
        title = "Services",
        caps = "SERVICES",
        subtitle = "What We Offer",
        path = "#services"
    ),
    Contact(
        id = "contact",
        title = "Contact",
        caps = "CONTACT",
        subtitle = "Get In Touch",
        path = "#contact"
    ),
}